import { fakeFetch } from '@/services/fetchService.js'
import notices from '@/services/data/notices.json'
import systemMessage from '@/services/data/systemMessage.json'

class MessageService {
  constructor() {
    this.type = 'mock'
  }

  fetchNotices = async () => {
    return fakeFetch(notices, 500) // wait 500ms before returning posts
  }

  fetchSystemMessage = async () => {
    return fakeFetch(systemMessage, 500) // wait 500ms before returning
  }
}

export default MessageService
export const messageService = new MessageService()
